import { useState, useEffect } from "react";

import styles from "./Input.module.scss";
import { DropdownSelect } from "components/UI/dropdowns/DropdownSelect";
import { isEqual } from "lodash";

export type Option = {
  name: string;
  value: string | number;
};

export type SelectProps = {
  label?: string;
  placeholder?: string;
  name: string;
  type?: string;
  mode?: "single" | "multiple";
  options?: Option[];
  initialValue?: string | string[];
  onChange?: (value?: string | string[]) => void;
  error?: boolean;
};

export const Select = ({
  label,
  placeholder,
  name,
  options,
  mode = "single",
  onChange,
  initialValue = "",
  error = false,
}: SelectProps) => {
  const [selectValue, setSelectValue] = useState<string | string[]>(mode === "single" ? "" : []);

  useEffect(() => {
    setSelectValue(initialValue);
  }, [initialValue]);

  if (!options) return null;

  return (
    <div className={styles.input}>
      {label && <span className={styles.inputLabel}>{label}</span>}
      <DropdownSelect
        placeholder={placeholder}
        mode={mode}
        items={options}
        error={error}
        initialValue={selectValue}
        onChange={(newValue: string | string[] = "") => {
          if (!isEqual(newValue, selectValue)) {
            setSelectValue(newValue);
            // timeout for update input value!!!
            setTimeout(() => {
              onChange && onChange(newValue);
            }, 0);
          }
        }}
      />
      <input type="hidden" name={name} value={selectValue} />
    </div>
  );
};
